import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HelpButton from "../components/HelpButton";
import SEO from "../components/SEO";
import { generateServiceSchema } from "../lib/schema";

function Privacy() {
  return (
    <div className="min-h-screen bg-gray-50 page-transition pt-[99px] md:pt-[133px]">
      <SEO
        title="Privacy - Elektraaanleggen.nl"
        description="Lees onze privacyverklaring en ontdek hoe Elektraaanleggen.nl omgaat met je persoonsgegevens en privacy. Wij respecteren je privacy en zorgen voor een veilige online ervaring."
        schema={generateServiceSchema({
          name: "Privacyverklaring",
          description:
            "Bij Elektraaanleggen.nl vinden we privacy belangrijk. Lees hoe we je gegevens verzamelen, gebruiken en beschermen volgens de geldende privacywetten.",
          image: "https://elektraaanleggen.nl/images/banner.png",
        })}
      />

      <Header />

      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] mb-12 md:mb-20 pt-16 md:pt-24">
        <h1 className="font-bold text-black leading-[1.25] text-[28px] lg:text-[36px] text-[#17354A] block mb-4 leading-[35px] text-[2rem] md:inline-block md:mb-5 md:text-[44px] md:leading-[42px] lg:block">
          Privacyverklaring
        </h1>

        <div className="text-black leading-[1.56] text-[16px] md:text-[18px] font-normal text-[#17354A] mb-8">
          <p>
            Bij elektraaanleggen.nl vinden we uw privacy erg belangrijk. In deze
            privacyverklaring leggen we uit welke gegevens we verzamelen en hoe
            we deze gebruiken.
          </p>

          <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6 mt-12">
            Welke gegevens verzamelen we?
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Naam en contactgegevens</li>
            <li>E-mailadres</li>
            <li>Telefoonnummer</li>
            <li>Adresgegevens</li>
            <li>Projectinformatie</li>
          </ul>

          <h2 className="font-bold text-[24px] lg:text-[36px] text-[#17354A] mt-12 mb-6">
            Waarvoor gebruiken we uw gegevens?
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Het uitbrengen van offertes</li>
            <li>Het uitvoeren van werkzaamheden</li>
            <li>Communicatie over projecten</li>
            <li>Facturatie en administratie</li>
            <li>Klantenservice en ondersteuning</li>
          </ul>

          <h2 className="font-bold text-[24px] lg:text-[36px] text-[#17354A] mt-12 mb-6">
            Hoe beschermen we uw gegevens?
          </h2>
          <p>
            We nemen passende technische en organisatorische maatregelen om uw
            gegevens te beschermen tegen verlies of onrechtmatige verwerking. Uw
            gegevens worden alleen gedeeld met partijen die betrokken zijn bij
            onze dienstverlening.
          </p>

          <h2 className="font-bold text-[24px] lg:text-[36px] text-[#17354A] mt-12 mb-6">
            Uw rechten
          </h2>
          <p>U heeft het recht om:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Uw gegevens in te zien</li>
            <li>Uw gegevens te laten corrigeren</li>
            <li>Uw gegevens te laten verwijderen</li>
            <li>Bezwaar te maken tegen de verwerking</li>
            <li>Een klacht in te dienen bij de Autoriteit Persoonsgegevens</li>
          </ul>

          <h2 className="font-bold text-[24px] lg:text-[36px] text-[#17354A] mt-12 mb-6">
            Contact
          </h2>
          <p>
            Heeft u vragen over ons privacybeleid? Neem dan contact met ons op
            via:
          </p>
          <p className="mt-4">
            elektraaanleggen.nl
            <br />
            Laan van vollenhove 2935 <br />
            3706 AK Zeist
            <br />
            info@elektraaanleggen.nl
          </p>
        </div>
      </section>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default Privacy;
